import React from "react";

function Notizie() {
    const news = [
        {
            title: "Nuovo sito Studio Legale Montis",
            text: "È online il nuovo sito dello Studio, uno spazio pensato per offrire informazioni chiare e accessibili sui servizi legali offerti e sull’approccio professionale che guida il mio lavoro quotidiano.\n" +
                "\n" +
                "Il sito nasce con l’obiettivo di creare un punto di contatto diretto con le persone, fondato su ascolto, trasparenza e dialogo. Qui è possibile conoscere le principali aree di attività, approfondire i valori che ispirano la mia professione e comprendere il metodo con cui affronto ogni incarico: un supporto concreto, onesto e orientato alla ricerca delle soluzioni più adeguate, senza creare false aspettative.\n" +
                "\n" +
                "Questo spazio vuole essere uno strumento utile e informativo, pensato per accompagnare chi si affida allo Studio anche nel primo approccio al mondo del diritto, con chiarezza e attenzione alle esigenze individuali.",
        }
    ];

    return (
        <section className="py-5 darkerContainer waves-container">
            <div className="container">
                <h2 className="mb-4">Notizie</h2>

                <div
                    id="notizieCarousel"
                    className="carousel slide"
                    data-bs-ride="carousel"
                    data-bs-interval="5000"
                >
                    <div className="carousel-indicators">
                        {news.map((_, idx) => (
                            <button
                                key={idx}
                                type="button"
                                data-bs-target="#notizieCarousel"
                                data-bs-slide-to={idx}
                                className={idx === 0 ? "active" : ""}
                                aria-current={idx === 0 ? "true" : undefined}
                                aria-label={`Slide ${idx + 1}`}
                            />
                        ))}
                    </div>

                    <div className="carousel-inner">
                        {news.map((n, idx) => (
                            <div
                                key={n.title}
                                className={`carousel-item ${idx === 0 ? "active" : ""}`}
                            >
                                <div className="p-4 rounded text-white carousel-inner-inner">
                                    <h5 className="light-color mb-2">{n.title}</h5>
                                    <p className="mb-0 justify-text">{n.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#notizieCarousel"
                        data-bs-slide="prev"
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Precedente</span>
                    </button>

                    <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#notizieCarousel"
                        data-bs-slide="next"
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Successivo</span>
                    </button>
                </div>
            </div>
        </section>
    );
}

export default Notizie;